import * as actionTypes from 'constants/ActionTypes';

const contracts = (state = {
    items: [],
    isLoaded: false,
}, action) => {
    switch (action.type) {
        case actionTypes.GET_CONTRACTS.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_CONTRACTS.SUCCESS: {
            return {
                ...state,
                items: action.data,
                isLoaded: true,
            };
        }
        case actionTypes.GET_CONTRACTS.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };

        case actionTypes.GET_TIME_CONTRACTS.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_TIME_CONTRACTS.SUCCESS: {
            return {
                ...state,
                items: action.data,
                isLoaded: true,
            };
        }
        case actionTypes.GET_TIME_CONTRACTS.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };

        default:
            return state;
    }
};

export default contracts;



// WEBPACK FOOTER //
// ./app/reducers/contracts.js